import React, { useState, useEffect } from 'react';
import Storage from '../../../services/storage.service';
import Translations from '../../../services/translation.service';
import CONSTANTS from '../../../services/constants.service';
import cardPay from "../../../assets/img/cardPay.svg"
import arrowRed from "../../../assets/img/arrow-right.svg"
import applePayIcon from '../../../assets/img/apple-pay.svg';
import applePayId from '../../../assets/img/apple-pay-id.svg';
import applePayFlatIcon from '../../../assets/img/ApplePayFlat.svg';
import CommonPaymentTap from '../../payment/common-payment-tap';
import Helpers from '../../../helpers/shared.helper';
import ApplePay from '../../../services/applePay.service';
import CommonPaymentLogo from '../../payment/common-payment-logo';

const CommonPayment = props => {
    const [openPaymentType, setOpenPaymentType] = useState(null);
    const [canApplePay, setCanApplePay] = useState(null);  
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );
    
    const subscriptions = [];
    useEffect(() => {
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        ApplePay.getApplyPayConfigureStatus()
        .then((canMakePayments) => {
            setCanApplePay(canMakePayments);
        })
        .catch((err) => {
            setCanApplePay(false);
        });

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleMethod = (method) => {
        if(props?.tapPayload?.extraInformation){
            let firePayInfo = {
                amt: props?.tapPayload?.extraInformation?.totalAmount || 0,
                type: props?.tapPayload?.extraInformation?.payingFor || ""
            }
            Storage.set("firePayInfo", JSON.stringify(firePayInfo), true)
        }
        props.selectedPaymentMethod(method);
		setOpenPaymentType(method);
	}

    const renderProcessPayment = () => {
        let paymentContent = null;
        if (openPaymentType === CONSTANTS.PAYMENT_METHOD_APPLE) {
            Storage.set("selected_payment_method", CONSTANTS.PAYMENT_METHOD_APPLE, true);
            // paymentContent = <ApplePayComponent applePayload={props.applePayload} />
            let applePayload = props.applePayload;
            // Check if the total amount exists & is not 0
            if (applePayload?.extraInformation?.totalAmount > 0) {
                // Params Definition: Total Amount, Payment Object for Apple, API details like endpoint, method. 
                ApplePay.appleBegin(applePayload?.extraInformation?.totalAmount, applePayload?.paymentData, applePayload?.apiEndpoint)
            }
        } else if (openPaymentType === CONSTANTS.PAYMENT_METHOD_TAP) {
            Storage.set("selected_payment_method", CONSTANTS.PAYMENT_METHOD_TAP, true);
            paymentContent = <CommonPaymentTap tapPayload={props.tapPayload} hideAppDownloads={props?.hideAppDownloads}/>
        }
        return paymentContent;
    }
    
    const tapPay = () => {
        let tap_option = null;
        // Check if we need to show Tap Payment
        let enableTapPaymentenable = Helpers.CheckEnableTapPayment();
        if(enableTapPaymentenable) {
            if(props.uiType === "flatUI") {
                tap_option = <div 
                    className={`common-payment-method-flat-ui ${!props.paymentDisabled && props?.tapPayload?.extraInformation?.totalAmount > 0 ? "" : "common-payment-method-disabled"}`}
                    onClick={() => {
                        if(props.paymentDisabled) return
                        if(props?.tapPayload?.extraInformation?.totalAmount > 0) {
                            if(props?.tapPayload?.paymentData) {
                                Storage.set("paymentProps", JSON.stringify(props.tapPayload?.paymentData.bill_payment_data), true);
                            }
                            if(props?.clickMimick) {
                                Storage.set("selected_payment_method", CONSTANTS.PAYMENT_METHOD_TAP, true);
                                Storage.set("SelectedPaymentMethodTemp", CONSTANTS.PAYMENT_METHOD_TAP);
                                props.history.push({
                                    pathname: '/bill-payment/payment',
                                    state: { paymentProps: props }
                                });
                                // Route to the Payment Screen
                            } else {
                                props.showPaymentOnly(true);
                                handleMethod(CONSTANTS.PAYMENT_METHOD_TAP);
                            }
                        }
                    }}
                >
                    {translationKeys["stm_pay_with_crd"] || "Pay with card"}
                </div> 
            } else {
                tap_option = (
                    <div
                        className={`common-payment-method ${!props.paymentDisabled && props?.tapPayload?.paymentData?.amount > 0 ? "" : "common-payment-method-disabled"}`} 
                        onClick={() => {
                            if(props.paymentDisabled) return
                            if(props?.tapPayload?.paymentData?.amount > 0) {
                                props.showPaymentOnly(true);
                                handleMethod(CONSTANTS.PAYMENT_METHOD_TAP);
                            }
                        }}
                    >
                        <div className="common-payment-method-content-wrapper">
                            <img src={cardPay} alt="cardPlay" />
                            <div className="common-payment-method-text-wrapper">
                                <div className="common-payment-method-title">
                                    <div className="common-payment-method-pay-img">
                                        <img src={cardPay} alt="cardPlay" />
                                    </div>
                                    {translationKeys["stm_common_payment_card_heading"] + " "}
                                </div>
                                <div className="common-payment-method-desc">
                                    {translationKeys["stm_common_payment_card_desc"]}
                                </div>
                            </div>
                        </div>
                        <div className="common-payment-btn">
                            <img src={arrowRed} alt="arrowRed" />
                        </div>
                    </div>
                );
            }
        }
        return tap_option
    }

    const applePay = () => {
        let apple_pay_option = null;
        if (canApplePay) {
            if(props.uiType === "flatUI") {
                apple_pay_option = <div 
                    className={`common-payment-method-flat-ui flat-ui-apple ${!props.paymentDisabled && props?.applePayload?.extraInformation?.totalAmount > 0 ? "" : "common-payment-method-disabled"}`}
                    onClick={() => {
                        if(props.paymentDisabled) return
                        if(props?.applePayload?.extraInformation?.totalAmount > 0) {
                            if(props?.tapPayload?.paymentData) {
                                Storage.set("paymentProps", JSON.stringify(props.tapPayload?.paymentData.bill_payment_data), true);
                            }
                            props.showPaymentOnly(false);
                            handleMethod(CONSTANTS.PAYMENT_METHOD_APPLE);
                        }
                    }}
                >
                    {translationKeys["stm_pay_with"] || "Pay with"}{" "}
                    <img src={applePayFlatIcon} alt="applePay" />
                </div>
            } else {
                apple_pay_option = (
                    <div
                        className={`common-payment-method ${!props.paymentDisabled && props?.applePayload?.paymentData?.amount > 0 ? "" : "common-payment-method-disabled"}`} 
                        onClick={() => {
                            if(props.paymentDisabled) return
                            if(props?.applePayload?.paymentData?.amount > 0) {
                                props.showPaymentOnly(false);
                                handleMethod(CONSTANTS.PAYMENT_METHOD_APPLE);
                            }
                        }}
                    >
                        <div className="common-payment-method-content-wrapper">
                            <img src={applePayId} alt="applePay" />
                            <div className="common-payment-method-text-wrapper">
                                <div className="common-payment-method-title">
                                    <div className="common-payment-method-pay-img">
                                        <img src={applePayId} alt="applePay" />
                                    </div>
                                    {translationKeys["stm_common_payment_apple_heading"] || "Pay with"}
                                    <img src={applePayIcon} alt="applePay" />{" "}
                                </div>
                                <div className="common-payment-method-desc">
                                    {translationKeys["stm_common_payment_apple_desc"] ||
                                    "Make payment securely and easy using your Apple Pay"}
                                </div>
                            </div>
                        </div>
                        <div className="common-payment-btn">
                            <img src={arrowRed} alt="arrowredApplePay" />
                        </div>
                    </div>
                );
            }
        }
        return apple_pay_option;
    }

    return (
        <>
            <div className="common-payment-container">
                {openPaymentType ? renderProcessPayment() :
                <>
                    {props?.hideForZeroPayment && props?.tapPayload?.paymentData?.amount <= 0 ? "" : applePay()}
                    {props?.hideForZeroPayment && props?.applePayload?.paymentData?.amount <= 0 ? "" : tapPay()}
                </>}
                {props.hidePaymentLogo ? "" : <CommonPaymentLogo />}
            </div>
        </>

    )
}

export default CommonPayment;